"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _escapeRegExp = _interopRequireDefault(require("../../../utils/escapeRegExp"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var _Input = _interopRequireDefault(require("../../Input"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // текущий элемент списка в фокусе
      focusedElement: null,
      focus: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFocus", function (event) {
      _this.setState({
        focus: true,
        focusedElement: -1
      });

      if (typeof _this.props.onFocus === 'function') {
        _this.props.onFocus(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBlur", function (event) {
      // blur всплывает первее чем клик по элементу списка.
      setTimeout(function () {
        _this.setState({
          focus: false,
          focusedElement: -1
        });

        if (typeof _this.props.onBlur === 'function') {
          _this.props.onBlur(event);
        }
      }, 200);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleKeyDown", function (event) {
      if (_this.state.focus) {
        if (event.keyCode === 40) {
          _this.focusNext();
        } else if (event.keyCode === 38) {
          _this.focusPrev();
        } else if (event.keyCode === 13) {
          event.preventDefault();

          _this.select();
        }
      }

      if (typeof _this.props.onKeyDown === 'function') {
        _this.props.onKeyDown(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (el) {
      _this.input = el;
      var elementRef = _this.props.elementRef;

      if (typeof elementRef === 'function') {
        elementRef(el);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = el;
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "_filter",
    value: function _filter() {
      var pattern = null;
      var _this$props = this.props,
          children = _this$props.children,
          value = _this$props.value,
          match = _this$props.match,
          result = [];

      if (children) {
        if (value && !match) {
          pattern = new RegExp((0, _escapeRegExp["default"])(value), 'i');
        }

        _react["default"].Children.forEach(children, function (child) {
          if (typeof match === 'function' && match(child.props.value, child)) {
            result.push(child);
          } else if (!pattern || pattern.test(child.props.value)) {
            result.push(child);
          }
        });
      }

      return result;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.state.focusedElement !== index) {
        return this.setState({
          focusedElement: index
        });
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var focused = this.state.focusedElement;
      var listLength = this._currentFilteredList.length;

      if (listLength) {
        // следующий индекс не больше чем длинна списка
        if (focused + 1 <= listLength - 1) {
          focused += 1;
        } else {
          focused = 0;
        }

        this._focus(focused);
      }
    }
  }, {
    key: "focusPrev",
    value: function focusPrev() {
      var focused = this.state.focusedElement;
      var listLength = this._currentFilteredList.length;

      if (listLength) {
        // следующий индекс не меньше первого
        if (focused - 1 >= 0) {
          focused -= 1;
        } else {
          // последний в списке
          focused = listLength - 1;
        }

        this._focus(focused);
      }
    }
    /**
     * выбор элемента из списка
     * @param {object} element
     */

  }, {
    key: "select",
    value: function select(element) {
      var value;
      var onSelect = this.props.onSelect;

      if (!element && this.state.focusedElement !== null) {
        element = this._currentFilteredList[this.state.focusedElement];
        value = element ? element.props.value : null;
      } else if (element) {
        value = element.props.value;
      }

      if (value) {
        this.value = value;

        if (typeof onSelect === 'function') {
          onSelect(value, element);
        }
      }
    }
  }, {
    key: "value",
    set: function set(value) {
      var target = _objectSpread({}, this.input, {
        value: value
      });

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target));
      }
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  // max length of elements list
  maxListLength: 6,
  component: _Input["default"]
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  /**
   * max length of elements list
   */
  maxListLength: _propTypes["default"].number,
  children: _propTypes["default"].any,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  value: _propTypes["default"].any,
  match: _propTypes["default"].func,
  component: _propTypes["default"].func,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     *@default palette.elPrimary
     */
    listBackground: _propTypes["default"].string,

    /**
     *@default palette.elPrimary
     */
    listBorderColor: _propTypes["default"].string,

    /**
     *@default 0 6px 10px 0 ${palette.elShadow}, 0 4px 10px 0 ${palette.elShadow}
     */
    listBoxShadow: _propTypes["default"].string,

    /**
     *@default palette.tsNormal
     */
    itemFontSize: _propTypes["default"].string,

    /**
     *@default 1.5
     */
    itemLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default palette.tActive
     */
    itemColor: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    hoverItemBackground: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    focusItemBackground: _propTypes["default"].string,

    /**
     *@default palette.elLightest
     */
    activeItemBackground: _propTypes["default"].string,

    /**
     *@default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     *@default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Autocomplete');
var _default = Main;
exports["default"] = _default;